<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8 8C8.79113 8 9.56448 7.76541 10.2223 7.32588C10.8801 6.88635 11.3928 6.26164 11.6955 5.53074C11.9983 4.79983 12.0775 3.99556 11.9231 3.21964C11.7688 2.44372 11.3878 1.73098 10.8284 1.17157C10.269 0.612165 9.55629 0.231202 8.78036 0.0768607C8.00444 -0.0774802 7.20017 0.00173314 6.46927 0.304484C5.73836 0.607234 5.11365 1.11992 4.67412 1.77772C4.2346 2.43552 4 3.20888 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8ZM8 10C5.33013 10 0 11.3403 0 14V16H16V14C16 11.3403 10.6699 10 8 10Z"
			fill="#170C3A"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-account',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
path.a {
	fill: none;
}
</style>

<docs>
	IconAccount

	```js
	<b-icon-account />
	```
</docs>
